export default {
  requestsInProgress: 0,
  modals: {
    addService: {
      visible: false,
    },
  },
  service: null,
  schema: null,
};
